<template>
  <div>
    <v-card class="shadow">
      <TableHeader
        title="لیست شرکت ها"
        @updateSelect="(e) => (headersSelected = e)"
        :exc-data="ListCompanies"
        :filter-headers="headers"
        :filter-headers-select="headersSelected"
        :exc-columns="columns"
        v-model="search"
        @input="(e) => (search = e)"
      />
      <v-data-table
        :headers="headersSelected"
        :items="ListCompanies"
        :search="search"
        :loading="loading"
      >
        <template v-slot:item.company.status="{ item }">
          {{ item.status ? "فعال" : "غیر فعال" }}
        </template>

        <template v-slot:item.company.score="{ item }">
          <v-rating
            v-if="item.company.score"
            v-model="item.company.score"
            readonly
            background-color="yellow"
            color="yellow accent-4"
            dense
            size="13"
          ></v-rating>
        </template>

        <template v-slot:item.company.verify="{ item }">
          <v-tooltip v-if="item.company.verify" top max-width="250">
            <template v-slot:activator="{ on, attrs }">
              <button v-on="on" v-attrs="attrs">
                <VIcon size="20" color="primary">mdi-check-decagram</VIcon>
              </button>
            </template>
            <span class="text-[10px]">تایید احراز هویت</span>
          </v-tooltip>
          <button
            @click="handelAuthBox(item.company.id, item.company.verify)"
            v-else
            class="text-[11px] min-w-max bg-blue-500 text-blue-100 rounded-md px-2 py-1"
          >
            احراز هویت
          </button>
        </template>
        <template v-slot:item.company.wallet="{ item }">
          {{ Seprate(item.company.wallet) }}
        </template>
        <template v-slot:item.operations="{ item }">
          <v-menu
            transition="slide-x-transition"
            bottom
            right
            origin="center center"
          >

            <template v-slot:activator="{ on, attrs }">
              <MoreBtn v-bind="attrs" v-on="on"></MoreBtn>
            </template>
            <v-list>
              <router-link
                :to="'/companies/detail/' + item.company.id"
                v-show="getPermissionMixin('company-detail')"
              >
                <v-list-item link>
                  <v-list-item-title>
                    <span style="font-size: 12px">اطلاعات شرکت</span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
              <v-list-item
                @click="handelAuthBox(item.company.id, item.company.verify)"
              >
                <v-list-item-title>
                  <span style="font-size: 12px">احراز هویت</span>
                </v-list-item-title>
              </v-list-item>
              <router-link
                :to="'/companies/turnOver/' + item.company.id"
                v-show="getPermissionMixin('turnOvers')"
              >
                <v-list-item link>
                  <v-list-item-title>
                    <span style="font-size: 12px">گردش مالی</span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
              <router-link
                :to="'/companies/users/' + item.company.id"
                v-show="getPermissionMixin('company-users')"
              >
                <v-list-item link>
                  <v-list-item-title>
                    <span style="font-size: 12px">کاربران شرکت</span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
              <router-link
                :to="'/companies/receipts/' + item.company.id"
                v-show="getPermissionMixin('receipts')"
              >
                <v-list-item link>
                  <v-list-item-title>
                    <span style="font-size: 12px">فیش های شرکت</span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
              <router-link
                :to="'/remittanceDischarge?company=' + item.company.id"
                v-show="getPermissionMixin('remittance-discharge')"
              >
                <v-list-item link>
                  <v-list-item-title>
                    <span>حواله تخلیه</span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
              <router-link
                :to="'/hall-announcement/list?company=' + item.company.id"
                v-show="getPermissionMixin('remittance-discharge')"
              >
                <v-list-item link>
                  <v-list-item-title>
                    <span>لیست اعلام بار سریع</span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <!-- <div>
        <PaginationOffline
          v-model="page"
          :currentView="per_page"
          :total="total"
          @perPage="(value) => (per_page = value)"
        ></PaginationOffline>
      </div> -->
    </v-card>
    <VDialog v-model="authData.boxAuth" max-width="650">
      <ModalTemplate v-model="authData.boxAuth" title="احراز هویت">
        <AuthNationalCompany
          @updateVerify="handelVerify"
          :verify="authData.verify"
          v-if="authData.boxAuth"
          userType="COMPANY"
          :userId="authData.userId"
        />
      </ModalTemplate>
    </VDialog>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import TableHeader from "@/components/Table/TableHeader.vue";
import AuthNationalCompany from "../../components/Admin/AuthNationalCompany.vue";
import ModalTemplate from "../../components/ModalTemplate";

// import PaginationOffline from "@/components/PaginationOffline.vue";

// import Pagination from '@/components/Pagination.vue';
import separate from "@/plugins/separate";

export default {
  name: "index",
  components: {
    TableHeader,
    // PaginationOffline,
    AuthNationalCompany,
    ModalTemplate,
  },
  data() {
    return {
      per_page: 10,
      total: 0,
      page: 1,
      loading: false,
      authData: {
        boxAuth: false,
        userId: "",
        verify: "",
      },
      items: [
        {
          text: this.$route.meta,
          disabled: true,
          href: "/",
        },
      ],
      ListCompanies: [],
      columns: [
        { label: "نام شرکت", field: "company.company_name" },
        { label: "کیف پول", field: "company.wallet" },
        { label: "نام مدیر", field: "company.managerName", status: true },
        { label: "فامیل مدیر", field: "company.managerFamily", status: true },
        { label: "ترمینال", field: "company.terminal.name", status: true },
        { label: "تلفن", field: "company.phone", status: true },
        { label: "موبایل", field: "mobile", status: true },
        { label: "امتیاز", field: "company.score", status: true },
        { label: "وضعیت", field: "company.status", dataFormat: this.translate },
        { label: "احراز هویت", field: "company.verify" },
      ],
      headers: [
        {
          text: "نام شرکت",
          align: "start",
          filterable: true,
          value: "company.company_name",
          status: true,
        },
        { text: "کیف پول", value: "company.wallet" },

        { text: "نام مدیر", value: "company.managerName", status: true },
        { text: "فامیل مدیر", value: "company.managerFamily", status: true },
        { text: "ترمینال", value: "company.terminal.name", status: true },
        { text: "تلفن", value: "company.phone", status: true },
        { text: "موبایل", value: "mobile", status: true },
        { text: "امتیاز", value: "company.score", status: true },
        { text: "وضعیت", value: "company.status", status: true },
        { text: "احراز هویت", value: "company.verify", status: true },
        { text: "عملیات", value: "operations", status: true },
      ],
      headersSelected: [
        {
          text: "نام شرکت",
          align: "start",
          filterable: true,
          value: "company.company_name",
        },
        { text: "کیف پول", value: "company.wallet" },

        { text: "نام مدیر", value: "company.managerName" },
        { text: "فامیل مدیر", value: "company.managerFamily" },
        { text: "ترمینال", value: "company.terminal.name" },
        { text: "تلفن", value: "company.phone" },
        { text: "موبایل", value: "mobile" },
        { text: "امتیاز", value: "company.score" },
        { text: "وضعیت", value: "company.status" },
        { text: "احراز هویت", value: "company.verify" },
        { text: "عملیات", value: "operations" },
      ],
      search: "",
    };
  },
  methods: {
    Separate(item) {
      return separate(item);
    },
    handelVerify() {
      this.authData.boxAuth = false;
      this.companies();
    },
    handelAuthBox(id, verify) {
      this.authData.boxAuth = true;
      this.authData.userId = id;
      this.authData.verify = verify;
    },
    companies() {
      this.loading = true;
      axiosApi()
        .get("v2/admin/company/getCompany")
        .then((result) => {
          this.ListCompanies = result.data.data.companies;
          this.total = result.data.data.companies.length;
          console.log(this.ListCompanies);
        })
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.companies();
  },
};
</script>

<style scoped>
</style>
